module.exports = __webpack_public_path__ + "img/header-plastico-filme.cf8985e9.png";